import { render, staticRenderFns } from "./ShippingHscodes.vue?vue&type=template&id=38131658&"
import script from "./ShippingHscodes.vue?vue&type=script&lang=js&"
export * from "./ShippingHscodes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports